export enum PanelType {
  Notifications = "Notifications",
  UserSettings = "My account",
  AppLauncher = "App launcher",
}
